import { Row, Col, Avatar, Image, message } from 'antd';
import { InstagramOutlined } from '@ant-design/icons';
import styles from './style.module.scss';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuthToken, getCurrentUser } from '../../utils/authHelpers';
import { useDispatch } from 'react-redux';
import { get_and_search_jobs } from '../../features/Jobseeker/jobseekerSlice';
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { useEffect } from 'react';

const Footer = () => {
    const navigate = useNavigate();
    const token = getAuthToken();
    const location = useLocation();
    const dispatch = useDispatch();
    let currentUser = getCurrentUser()

    const goToHome = () => {
        navigate('/');
        window.scrollTo(0, 0);
    };

    const onGopostJob = () => {
        if (currentUser === "organization") {
            navigate('/dashboard')
        } else {
            message.info("Only Organization can post jobs")
        }
    }

    // useEffect(() => {
    //     const badge = document.querySelector('.grecaptcha-badge');
    //     const showOnPaths = ['/request-demo']; 

    //     if (badge) {
    //         if (showOnPaths.includes(location.pathname)) {
    //             badge.style.visibility = 'visible';
    //         } else {
    //             badge.style.visibility = 'hidden';
    //         }
    //     }
    // }, [location.pathname]);

    useEffect(() => {
    const showOnPaths = ['/request-demo'];

    const toggleBadgeVisibility = () => {
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
            badge.style.visibility = showOnPaths.includes(location.pathname) ? 'visible' : 'hidden';
        }
    };

    const timer = setTimeout(toggleBadgeVisibility, 1000); // wait 1 second

    return () => clearTimeout(timer);
}, [location.pathname]);


    return (
        <div className={styles.footerContainer}>
            <div className={styles.footerContent}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={6}>
                        <div className={styles.footerLogo}>
                            <div onClick={goToHome} className={`${styles.logostyle} ${styles.cursorPointer} ${styles.flexRow}`}>
                                <Avatar
                                    shape="square"
                                    size={150}
                                    draggable={false}
                                    src={<Image draggable={false} preview={false} src={"https://eployrs-config-file.s3.ap-south-1.amazonaws.com/eployrs/Images/logo/EPLOYRS_LOGO_Text_white_V01.svg"} alt="Eployrs Logo" />}
                                />

                            </div>
                            <p className={`info-paragraph  ${styles.description}`}>
                                Build your professional network, explore career opportunities, and connect with industry leaders.
                            </p>
                            <div className={styles.socialIcons}>
                                <a target="_blank" rel="noopener noreferrer" className={styles.footerLink}
                                    href={process.env.REACT_APP_FACEBOOKE_URL}>
                                    <Avatar className={styles.footerSocialIcon} shape="circle" size={30} icon={<FaFacebookF />} /></a>
                                <a target="_blank" rel="noopener noreferrer" className={styles.footerLink}
                                    href={process.env.REACT_APP_LINKEDIN_URL}><Avatar className={styles.footerSocialIcon} shape="circle" size={30} icon={<FaLinkedinIn />} /></a>
                                <a target="_blank" rel="noopener noreferrer" className={styles.footerLink} href={process.env.REACT_APP_TWITTER_URL}>
                                    <Avatar className={styles.footerSocialIcon} shape="circle" size={30} icon={<FaXTwitter />} />
                                </a>
                                <a target="_blank" rel="noopener noreferrer" className={styles.footerLink} href={process.env.REACT_APP_INSTAGRAM_URL}>
                                    <Avatar className={styles.footerSocialIcon} shape="circle" size={30} icon={<InstagramOutlined />} />
                                </a>
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={12} md={6}>
                        <h3 className={`titleFont ${styles.footerHeading}`}>Legal</h3>
                        <ul className={styles.footerLinks}>
                            <li> <a href={'/privacy-policy'} target="_blank" rel="noopener noreferrer" className={`info-paragraph  ${styles.footerLink}`}>
                                Privacy Policy
                            </a></li>
                            <li> <a href={'/cookie-policy'} target="_blank" rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>
                                Cookies Policy
                            </a></li>
                            <li> <a href={'/abuse-policies'} target="_blank" rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>
                                Abuse Policy
                            </a></li>
                            <li> <a href={'/term-and-conditions'} target="_blank" rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>
                                Terms and Conditions
                            </a></li>
                            <li> <a href={'/trademark-policy'} target="_blank" rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>
                                Trademark Policy
                            </a></li>
                            <li >
                                <a onClick={() => navigate('/report-problem')} target="_blank" rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>
                                    Report Problem
                                </a>
                            </li>


                        </ul>
                    </Col>

                    <Col xs={24} sm={12} md={6}>
                        <h3 className={`titleFont ${styles.footerHeading}`}>Career Growth</h3>
                        <ul className={styles.footerLinks}>
                            <li><Link className='info-paragraph' to={token ? '/jobseeker/dashboard' : '/jobseeker'}>Job Listings</Link></li>
                            <li onClick={() => {
                                const navigationPage = token ? '/searched-jobs' : '/jobseeker';
                                dispatch(get_and_search_jobs({ navigate, searchParams: { searchString: 'Internship' } }));
                                navigate(navigationPage);
                            }}><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>Internship Programs</a></li>
                            <li className='info-paragraph'><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>Skill Development</a></li>
                        </ul>
                    </Col>

                    <Col xs={24} sm={12} md={6}>
                        <h3 className={`titleFont ${styles.footerHeading}`}>Employer Solutions</h3>
                        <ul className={styles.footerLinks}>
                            <li className='info-paragraph' onClick={onGopostJob}><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>Post a Job</a></li>
                            <li className='info-paragraph'><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>Company Branding</a></li>
                            <li className='info-paragraph'><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>Talent Search</a></li>
                            <li className='info-paragraph'><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>Recruiter Tools</a></li>
                            <li className='info-paragraph'><a rel="noopener noreferrer" className={`info-paragraph ${styles.footerLink}`}>HR Resources</a></li>
                        </ul>
                    </Col>


                </Row>
            </div>

            <div className={styles.footerBottom}>
                <p className='info-paragraph'>© 2024 Eployrs. All rights reserved.</p>
                <div><div onClick={goToHome} className={`${styles.cursorPointerBottom} ${styles.flexRow}`}>
                    <div onClick={goToHome} className={`${styles.logostyle} ${styles.cursorPointerBottom} ${styles.flexRow}`}>
                        <Avatar
                            shape="square"
                            size={40}
                            draggable={false}
                            src={<Image draggable={false} preview={false} src={"https://eployrs-config-file.s3.ap-south-1.amazonaws.com/eployrs/Images/logo/LOGO_ICON_WHITE_V01.svg"} alt="Eployrs Logo" />}
                        />

                    </div>
                </div></div>
            </div>
        </div>
    );
};

export default Footer;


